/**
 * The header's search (roadmap §11.6): looks like a box, opens the palette — from a click, `/`, or
 * Ctrl-K (⌘K on a Mac). `/` is ignored while a field has focus, so typing one into a form stays a
 * character.
 */
import { useEffect, type ReactNode } from 'react';
import { Icon } from '@/components/lumen/Icon';

export function SearchButton({ onOpen }: { onOpen: () => void }): ReactNode {
  useEffect(() => {
    const onKey = (e: KeyboardEvent): void => {
      const k = e.key.toLowerCase();
      const t = e.target as HTMLElement | null;
      const typing = t !== null && (/^(INPUT|SELECT|TEXTAREA)$/.test(t.tagName) || t.isContentEditable);
      if ((k === 'k' && (e.metaKey || e.ctrlKey) && !e.altKey) || (k === '/' && !typing && !e.metaKey && !e.ctrlKey && !e.altKey)) {
        e.preventDefault();
        onOpen();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onOpen]);
  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label="Search cabinets, alarms, sites, work and people (Ctrl K)"
      title="Search (/ or Ctrl K)"
      className="lm-hov flex items-center gap-[8px] rounded-[var(--radius-sm)] px-[9px] text-[12px]"
      style={{ height: 'var(--header-ctl-h)', border: '1px solid var(--border)', color: 'var(--muted-fg)' }}
    >
      <Icon name="ic-search" size={14} />
      <span className="hidden lg:inline">Search</span>
      <kbd className="hidden rounded-[4px] px-[4px] text-[10px] lg:inline" style={{ border: '1px solid var(--border)' }}>
        /
      </kbd>
    </button>
  );
}
